import React from 'react';
import TextField from '@material-ui/core/TextField';

function DatePickers(props) {
  return (
      <TextField
        id="date"
        onChange={props.onChange}
        type="date"
        // InputLabelProps={{
        //   shrink: true,
        // }}
        required
        {...props}
      />
  );
}

export default DatePickers;



// WEBPACK FOOTER //
// ./src/components/DatePickers.js